<template>
  <div class="section-container">
    <div class="container">
      <!--<div class="row">-->
        <!--<div class="col-sm-8 col-sm-offset-2 section-container-spacer">-->
          <!--<div class="text-center">-->
            <!--<h1 class="h2">03 : 自营</h1>-->
          <!--</div>-->
        <!--</div>-->
      <!--</div>-->
      <!-- 直接展开显示案例 -->
      <div class="worl-content" :class="{'mobile-modal' : isMobile}" v-for="(work, wIdx) in selfWorks" :key="wIdx">
        <div class="worl-body">
          <div class="row">
            <div class="col-xs-12">
              <div class="section-container-spacer text-center" >
                <h3 style="font-size: 30px; margin-top: 80px">{{work.name}}</h3>
              </div>
              <div class="row">
                <!-- 左边的图片案例 -->
                <div class="col-xs-12 col-md-8">
                  <!-- pc端案例展示 -->
                  <template v-if="work.bannerType === 'pc'">
                    <div class="pc-box">
                      <div :id="'pcCarousel'+wIdx" class="pc-carouse-item carousel slide" data-ride="carousel">
                          <div class="carousel-inner">
                                  <div class="item"
                                       v-for="(item,index) in work.banner"
                                       :class="{ 'active' :  index == 0 }">
                                      <img :src="item" />
                                  </div>
                          </div>
                        <a class="left carousel-control" :href="'#pcCarousel'+wIdx" data-slide="prev">‹</a>
                        <a class="right carousel-control" :href="'#pcCarousel'+wIdx" data-slide="next">›</a>
                      </div>
                    </div>
                  </template>
                  <!-- pc端案例展示 -->
                  <!-- mobile端案例展示 -->
                  <template v-if="work.bannerType === 'mobile'">
                    <div :id="'mobileCarousel'+wIdx" class="mobi-carouse-item carousel slide mobile-box" data-ride="carousel">
                        <div class="carousel-inner">
                            <div class="item"
                                 v-for="(item,index) in work.banner"
                                 :class="{ 'active' :  index == 0 }">
                                <img :src="item" />
                            </div>
                        </div>
                      <a class="left carousel-control" :href="'#mobileCarousel'+wIdx" data-slide="prev">‹</a>
                      <a class="right carousel-control" :href="'#mobileCarousel'+wIdx" data-slide="next">›</a>
                    </div>
                  </template>
                  <!-- mobile端案例展示 -->
                </div>
                <!-- 左边的图片案例 -->
                <!-- 右边的数据展示 -->
                <div class="col-xs-12 col-md-4">
                  <h3>类型</h3>
                  <p>{{work.appType}}/{{work.industryType}}</p>
                  <h3>日期</h3>
                  <p>{{work.date}}</p>
                  <h3>简述</h3>
                  <p>{{work.describe}}</p>
                    <template v-if="work.demoUrls && work.demoUrls.length">
                        <a v-for="item in work.demoUrls"
                           class="btn btn-default" style="margin-right: 15px"
                           :href="item.url" target="_blank">
                            {{ item.intro }}
                        </a>
                    </template>
                    <!-- 二维码 -->
                    <template v-if="work.qrLinks && work.qrLinks.length">
                        <div class="qr-item" v-for="(qr,qIdx) in work.qrLinks">
                            <h3>{{qr.title}}</h3>
                            <img class="qr-img" :src="qr.qrImg">
                        </div>
                    </template>
                    <!-- 二维码 -->
                </div>
                <!-- 右边的数据展示 -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { selfWorks } from '@/utils/data-source.js'
import { isMobile } from '@/utils/index.js'
export default {
  components: {},
  computed: {
    selfWorks() {
      return selfWorks
    }
  },
  data() {
    return {
      isMobile
    }
  },
  watch: {},
  methods: {},
  mounted() {},
}
</script>
<style lang="scss">
.worl-content {
  margin-bottom: 40px;

  .pc-box {
    width: 600px;
    height: 375px;
    margin: auto;
    background-image: url('../assets/images/work/pc-box.png');
    background-size: cover;
    background-repeat: no-repeat;
    position: relative;

    #pcCarousel {
      width: 407px;
      height: 242px;
      position: absolute;
      left: 100px;
      top: 40px;
    }

      #pcCarousel .carousel-inner {
          width: 100%;
          height: 100%;
          overflow: hidden;
      }

      .pc-carouse-item {
          width: 407px;
          height: 242px;
          position: absolute;
          left: 100px;
          top: 40px;
      }

      .pc-carouse-item .carousel-inner {
          width: 100%;
          height: 100%;
          overflow: hidden;
      }


    .left.carousel-control {
      left: -76px;
    }

    .right.carousel-control {
      right: -76px;
    }
  }

  .mobile-box {
    width: 520px;
    height: 520px;
    margin: auto;
    position: relative;

    &:after {
      position: absolute;
      z-index: 1;
      content: "";
      width: 400px;
      height: 400px;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      background-image: url('../assets/images/work/mobile-box.png');
      background-size: cover;
      background-repeat: no-repeat;
    }

    .carousel-inner {
      position: absolute;
        left: 145px;
        top: 11px;
        width: 230px;
        height: 497px;
      background: #000;
    }


    .left.carousel-control {
      left: 0px;
      z-index: 2;
    }

    .right.carousel-control {
      right: 0px;
      z-index: 2;
    }
  }

  &.mobile-modal {
    .pc-box {
      width: 320px;
      height: 200px;
      background-position: center;

      #pcCarousel {
        width: 219px;
        height: 130px;
        left: 53px;
        top: 20px;
      }
    }

    .mobile-box {
      width: 320px;
      height: 420px;
      margin-bottom: 60px;

      &:after {
        background-position: center;
      }

      .carousel-inner {
        left: 67px;
        top: 10px;
        width: 186px;
        height: 401px;
      }
    }
  }

}
</style>